import React, { useState, useEffect } from 'react';
import { 
  Map,
  Marker, 
  useMap
} from '@vis.gl/react-google-maps';

const GoogleMapPicker = ({ lat, lng, onLocationChange }) => {
  const map = useMap();

  // A jelölő belső állapota a sima mozgáshoz
  const [markerPosition, setMarkerPosition] = useState({
    lat: parseFloat(lat) || 47.1625, 
    lng: parseFloat(lng) || 19.5033 
  });

  // Ha a form mezőiből (keresés vagy kézi írás) változik a koordináta, ugorjunk oda
  useEffect(() => {
    const pLat = parseFloat(lat);
    const pLng = parseFloat(lng);

    if (!isNaN(pLat) && !isNaN(pLng)) {
      const newPos = { lat: pLat, lng: pLng };

      // Frissítjük a gombostűt
      setMarkerPosition(newPos);

      // Ha a koordináták jelentősen megváltoztak (pl. keresés történt),
      // akkor a térkép is ugorjon oda a közepére
      if (map) {
        map.panTo(newPos);
        // Ha nagyon messze mentünk, közelítsünk rá
        if (map.getZoom() < 10) map.setZoom(15);
      }
    }
  }, [lat, lng, map]);

  const handleDragEnd = (e) => {
    if (e.latLng) {
      const newLat = e.latLng.lat();
      const newLng = e.latLng.lng();
      const newPos = { lat: newLat, lng: newLng };
      
      setMarkerPosition(newPos);
      if (onLocationChange) {
        onLocationChange(newLat.toFixed(6), newLng.toFixed(6));
      }
    }
  };

  return (
    <div style={{ height: '100%', width: '100%', borderRadius: '12px', overflow: 'hidden' }}>
      <Map
        defaultCenter={markerPosition}
        defaultZoom={7}
        gestureHandling={'greedy'}
        disableDefaultUI={false}
        mapId={'bf51a910020fa566'}
      >
        <Marker
          position={markerPosition}
          draggable={true}
          onDragEnd={handleDragEnd}
        />
      </Map>
    </div>
  );
};

export default GoogleMapPicker;
